import { Link } from 'react-router-dom';
import { featuredContent } from '@/mocks/home';

export default function FeaturedContent() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">精选内容</h2>
            <p className="text-sm text-foreground-500 mt-2">编辑团队精心挑选的优质内容</p>
          </div>
          <Link
            to="/category"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line text-sm" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuredContent.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="group block cursor-pointer"
            >
              <article className="bg-background-100 rounded-lg overflow-hidden transition-transform duration-300 group-hover:-translate-y-1">
                <div className="relative w-full h-48 md:h-52 overflow-hidden">
                  <img
                    src={item.cover}
                    alt={item.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    title={`${item.title} - 蜜桃传媒精品内容`}
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-xs font-medium text-foreground-700 whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
                    {item.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-400">
                    <div className="flex items-center gap-1.5">
                      <i className="ri-user-line text-xs" />
                      <span>{item.author}</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line text-xs" />
                        {item.views}
                      </span>
                      <span>{item.date}</span>
                    </div>
                  </div>
                </div>
              </article>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category"
            className="inline-flex items-center gap-1 text-sm text-primary-500 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line text-sm" />
          </Link>
        </div>
      </div>
    </section>
  );
}